<template>
    <el-dialog v-if="is_load" v-model="dialogMenusVisible" width="40%">
        <el-tabs v-model="activeName" class="demo-tabs" @tab-change="handleClick">
            <el-tab-pane :label="item.title" :name="index" v-for="(item, index) in lists" :key="index"></el-tab-pane>
            <el-tab-pane label="其他" name="other"></el-tab-pane>
        </el-tabs>
        <el-table v-if="activeName !== 'other'" :data="tableData" stripe style="width: 100%">
            <el-table-column prop="title" label="名称" />
            <el-table-column v-if="appType == 1" prop="appurl" label="链接" />
            <el-table-column v-if="appType == 0" prop="url" label="链接" />
            <el-table-column label="操作">
                <template #default="scope">
                    <el-button link type="primary" size="small" @click="tableClick(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-table v-else :data="tableData" stripe style="width: 100%">
            <el-table-column prop="title" label="名称" />
            <el-table-column prop="name" label="标题" #default="scope">
                <el-input v-model="scope.row.name" />
            </el-table-column>
            <el-table-column prop="url" label="链接" #default="scope">
                <el-input v-model="scope.row.url" />
            </el-table-column>
            <el-table-column label="操作" >
                <template #default="scope">
                    <el-button link type="primary" size="small" @click="tableClick(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, inject } from 'vue'
    import Api from '@/config/api'
    export default defineComponent({
        props: {
            dataUrl: {
                type: String,
                default: ''
            },
            params: {
                type: Object,
                default: () => {}
            }
        },
        setup(props, context) {
            const dialogMenusVisible = inject('dialogMenusVisible')
            const { proxy } = getCurrentInstance()
            const activeName = ref('other')
            const is_load = ref(false)
            const lists = ref()
            const tableData = ref()
            const appType = ref(1)
            const other = ref([
                {
                    title: '返回',
                    name: '返回',
                    url: 'back'
                },
                {
                    title: '拨打电话',
                    name: '联系我们',
                    url: 'tel:'
                },
                {
                    title: '二维码',
                    name: '扫描',
                    url: 'scanCode'
                }
            ])
            const setAppType = (e) => {
                appType.value = e
            }
            let url = Api.OperationMenuMenus
            if (props.dataUrl) {
                url = props.dataUrl
            }
            proxy.jiu.request(url, props.params).then((res, rej) => {
                if (res.data.length > 0) {
                    activeName.value = 0
                    tableData.value = res.data[0].nav_list
                }
                lists.value = res.data
                is_load.value = true
            }).catch((error) => {
                proxy.jiu.showError(error)
            })
            const handleClick = (e) => {
                if (e !== 'other') {
                    tableData.value = lists.value[e].nav_list
                } else {
                    tableData.value = other.value
                }
            }
            const tableClick = (e) => {
                let name = e.name
                let url = e.url
                if (activeName.value !== 'other') {
                    name = e.title
                    url = e.url
                    if (appType.value === 1) url = e.appurl
                }
                context.emit('update:onUrlChange', {
                    name: name,
                    url: url
                })
            }
            return {
                handleClick,
                tableClick,

                lists,
                tableData,
                is_load,
                activeName,
                dialogMenusVisible,
                appType,
                setAppType
            }
        }
    })
</script>

<style>
</style>
